<mat-toolbar color="primary" class="navbar">
  <span class="navbar-logo">
    <img src="assets\dexcat__4_-removebg-preview.png" (click)="redirect()" alt="Company Logo">
  </span>
  <span class="spacer"></span>
    <button (click)="logout()" mat-button color="primary">Logout</button>

</mat-toolbar>
